import { ThemeI } from '../declarations/interfaces/theme';

const QUERY_TYPE = '@media only screen';

// This is the old theme model, such object receives from admin panel
export const oldTheme = {
  name: 'Default',
  backgroundColour: '#fff',
  borderColour: '#606060',
  buttonColour: '#63d089',
  disabledColour: '#cacaca',
  font: {
    name: 'Montserrat',
    variant: 'regular',
    url: 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  },
  fontSize: '14',
  footerColour: '#f3f3f3',
  headerColour: '#1e1e1e',
  headersFont: {
    name: 'Montserrat',
    variant: 'regular',
    url: 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  },
  linkColour: '#00cc37',
  primaryColour: '#63d089',
  secondaryFont: {
    name: 'Montserrat',
    variant: 'regular',
    url: 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  },
  secondaryTextColour: '#444',
  subHeaderColour: '#212529',
  textColour: '#212529',
  whiteColour: '#fff',
};

export const breakpoints = {
  mobile: 360,
  tablet: 768,
  desktop: 1170,
};

export const mainTheme: ThemeI = {
  ...oldTheme,
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  fontSizes: {
    xSmall: '12px',
    small: '14px',
    normal: '16px',
    medium: '18px',
    large: '20px',
    xLarge: '28px',
    largest: '30px',
  },
  // prettier-ignore
  devices: {
    mobile: `${QUERY_TYPE} and (max-width: ${breakpoints.tablet - 1}px)`,
    tabletOnly: `${QUERY_TYPE} and (min-width: ${breakpoints.tablet}px) and (max-width: ${breakpoints.desktop - 1}px)`,
    tabletAndDesktop: `${QUERY_TYPE} and (min-width: ${breakpoints.tablet}px)`,
    tabletOnlyLandscape: `${QUERY_TYPE} and (min-width: ${breakpoints.tablet}px) and (max-width: ${breakpoints.desktop - 1}px) and (orientation: landscape)`,
    mobileLandscape: `${QUERY_TYPE} and (max-width: ${breakpoints.tablet - 1}px) and (orientation: landscape)`,
    touch: `${QUERY_TYPE} and (max-width: ${breakpoints.desktop - 1}px)`,
    desktop: `${QUERY_TYPE} and (min-width: ${breakpoints.desktop}px)`,
    iOS: `${QUERY_TYPE} and (-webkit-min-device-pixel-ratio: 2)`
  },
};

export default mainTheme;
